/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "entityRelationDefs",
    graphQL: "EntityRelationDef",
    name: "Entity Relation Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'entityRelationDefs',
    onModify: ['groupDef'],
    fields: (types) => { return {
        id: {
            name: "Entity Relation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            translatable: true,
            type: "string",
        },
        key: {
            name: "Key",
            type: "string",
            trim: true,
            validations: {
                matchRegexp: /^[a-zA-Z0-9\.\-_]+$/,
            },
            isPublic: true,
        },
        description: {
            name: "Description",
            translatable: true,
            type: "text",
        },
        entityDef: {
            name: "Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        toEntity: {
            name: "To Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
